// ŚledźGPS colour palette for JS (canvas, Leaflet styles, inline styles).
// COPY of sledz-app/src/config/palette.js - the source is sledz-app; change a colour there first,
// then in every copy (sledz-org, results, sledz-web). CSS: src/styles/palette.css (same values as --sledz-*).
// Rules and swatches: docs/palette.md.
export const PALETTE = Object.freeze({
  // Brand (logo)
  brand: "#f1c40f", // logo yellow - Superman, highlights; never for long text
  brandInk: "#2b2a29", // logo graphite - text/outline on brand yellow

  // Primary action (buttons, active tabs, links on light background)
  primary: "#2196f3",
  primaryStrong: "#1976d2", // hover, text in primary colour on white
  primaryDeep: "#1565c0", // pressed, text on primarySoft
  primarySoft: "#e3f2fd", // selected background on light UI

  // Dark panels ("Lista", "Wyniki live", checkpoint, statistics)
  panel: "#364959",
  panelDeep: "#2c3d4a", // panel headers, tiles, chips over the map
  panelHover: "#53585c",
  panelText: "#ffffff",
  panelTextSubtle: "#cbd5df",
  panelTextMuted: "#9fb2c1",
  panelLink: "#7fc4ff",
  bibBadge: "#367fad", // default runner number badge

  // Light UI neutrals
  surface: "#ffffff",
  surfaceAlt: "#f8fafc",
  border: "#d1d5db",
  borderSoft: "#e5e7eb",
  text: "#1f2937",
  textSecondary: "#475569",
  textMuted: "#64748b",

  // Status
  live: "#dc2626", // "Na żywo", errors
  liveStrong: "#b91c1c",
  success: "#2e7d32",
  successBright: "#4caf50",
  warning: "#f59e0b",
  warningInk: "#92400e",
  warningSoft: "#fef3c7",

  // Changed results row (results.sledzgps.pl, panel ORG; not used in sledz-app yet)
  highlight: "#ebd0b2", // background of a row that just changed
  highlightFlash: "#ffa754", // start of the flash animation fading into highlight

  // Runner gender (runnerGender.js GENDER_COLORS)
  genderK: "#d81b60",
  genderM: "#1976d2",

  // Places 2 and 3 (medal badges; the 1st place uses brand yellow)
  medalSilver: "#c0c7cf",
  medalBronze: "#cd7f32",
});
